import { Chip, styled } from "@mui/material";
import { Realm } from "api/types";
import clsx from "clsx";
import "./Realm.scss";
import { realmsMap } from "./realms";

const StyledChip = styled(Chip)(({ theme }) => ({
	marginRight: theme.spacing(1),
	marginBottom: theme.spacing(1),
	padding: theme.spacing(1),
	backgroundColor: theme.palette.grey[200],
}));

export interface RealmTagProps {
	selected?: boolean;
	name: Realm;
	onClick?: (name: Realm) => void;
	onDelete?: (name: Realm) => void;
}

export const RealmTag = ({
	selected,
	name,
	onClick,
	onDelete,
}: RealmTagProps): JSX.Element => {
	const realm = realmsMap[name];

	// Conditionally defining the following handlers allows us to hide the `Chip` buttons in some cases
	const handleClick = onClick && (() => onClick?.(name));
	const handleDelete = onDelete && (() => onDelete?.(name));

	return (
		<StyledChip
			className={clsx(
				"tag",
				selected === false ? "unselected" : "selected",
				realm.className,
			)}
			key={name}
			label={name}
			icon={realm.icon}
			onClick={handleClick}
			onDelete={handleDelete}
		/>
	);
};
